/**** cat.DevMNTType */

const config = {
  schema: 'mgt',
  table: 'Routes',
  title: 'Маршруты',
  elemsOnPage: 10,
  connections: {
    transporttype: {
      schema: 'mgt',
      table: 'TransportType',
      index: 'note',
      fields: ['title'],
      format: (elem: any) => elem['title'],
    },
    marshtype: {
      schema: 'mgt',
      table: 'MarshType',
      index: 'id',
      fields: ['title'],
      format: (elem: any) => elem['title'],
      autocomplete: true,
    },
    agencies: {
      schema: 'mgt',
      table: 'Depot',
      index: 'depot_id',
      fields: ['depot_name'],
      format: (elem: any) => elem['depot_name'],
    },
  },
  fields: [
    {
      name: 'route_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true
    },
    {
      name: 'route_long_name',
      title: 'Наименование',
      type: 'text',
      required: true,
      width: '30%',
    },
    {
      name: 'route_type',
      title: 'Тип ТС',
      type: 'text',
      required: true,
      connection: 'transporttype',
    },
    {
      name: 'MarshType_id',
      title: 'Вид сообщения',
      type: 'number',
      required: true,
      connection: 'marshtype',
    },
    {
      name: 'route_short_name',
      title: 'Номер маршрута',
      type: 'text',
      required: true,
      width: '30%',
    },
    {
      name: 'route_desc',
      title: 'Альтернативное наименование',
      type: 'text',
      required: true,
      width: '30%',
    },
    {
      name: 'Depot_id',
      title: 'Филиал',
      type: 'number',
      required: false,
      connection: 'agencies',
      link: 'park',
    },
    {
      name: 'startdate',
      title: 'Дата ввода в действие',
      type: 'date',
      required: false,
    },
    {
      name: 'enddate',
      title: 'Дата окончания действие',
      type: 'date',
      required: false,
    },
    {
      title: 'Рейсы',
      type: 'map',
      disableFilter: true,
      composite: {
        type: 'trip',
        field: 'route_id',
      },
    },
  ],
  defaultSort: {
    field: 'route_id',
    direction: 'desc',
  },
  makeTitle: (elem: any, connections: { [key: string]: any }): string => {
    return `${elem['route_short_name']} (${elem['route_long_name']})`;
  },
  makeAdditional: (elem: any, connections: { [key: string]: any }): string => {
    const tt =
      connections &&
      connections['transporttype'] &&
      connections['transporttype'].find(
        (tp: any) => tp['note'] === elem['route_type']
      );
    const mt =
      connections &&
      connections['marshtype'] &&
      connections['marshtype'].find(
        (mm: any) => mm['id'] === elem['MarshType_id']
      );
    const dp =
      connections &&
      connections['agencies'] &&
      connections['agencies'].find(
        (ag: any) => ag['depot_id'] === elem['Depot_id']
      );
    return `Тип: ${(tt && tt['title']) || ''}; Вид сообщения: ${(mt &&
      mt['title']) ||
      '-'}; Филиал: ${(dp && dp['depot_name']) || '-'}`;
  },
};

export default config;
